import _ from 'underscore';
import moment from 'moment';
import Autolinker from 'autolinker';
import Ladda from 'ladda';
import twemoji from 'twemoji';

import 'dotdotdot';
import 'initial-js';

import UICommunity from '@/scripts/legacy-ui-library/ui-community';

import AcHelper from '@/scripts/helpers/ac-helper';
import UIHelper from '@/scripts/helpers/ui-helper';
import socialSharer from '@/scripts/libs/social-sharer';

import VSCommunityQuestion from './vs-community-question';
import VSCommunityResponse from './vs-community-response';

import BrowserStorage from '@/scripts/helpers/browser-storage';
import loginController from '@/scripts/libs/login/controller';
import viddsee from '@/scripts/viddsee';
import webcall from '@/scripts/webcall';

const _question = {
  id: '',
  slug: '',
};

const _initPageData = function _initPageData() {
  // Sets the page's question id.
  _question.id = $('#question, #response').attr('data-question-id');
  _question.slug = $('#question, #response').attr('data-question-slug');

  // Set's the current page for comment to -1
  $('#comments__see-more').data('current-page', -1);
};

const _initProfileImageInitial = function _initProfileImageInitial() {
  $('.content .avatar').each((index, avatarElement) => {
    const $this = $(avatarElement);
    if ($this.attr('src') === '' && typeof $this.data('name') !== 'undefined') {
      $this.initial();
    }
  });
};

const _bindUIActions = function _bindUIActions() {
  // Flagging
  $('body').on('click', '.js-community-flag-login', (e) => {
    e.preventDefault();
    ga('send', 'event', 'community', 'login-flag');
    viddsee.ui.modal.register.open({
      loginReason: I18n.t('javascript.login-reason.common-flag-interaction'),
    });
  });

  $('#modal--flag').on('vs:app:community:flag', (e, isComment) => {
    _flag(e, isComment);
  });

  $('body').on('vs:app:community:share', '.js-community-share', (e) => {
    _share(e);
  });

  $('#comments').on('click', '.comment__new__send--login, .comment__item__login', (e) => {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const callback = {
      loginReason: I18n.t('javascript.login-reason.common-community-interaction'),
    };

    if ($target.hasClass('comment__new__send--login')) {
      callback.callback = 'community_question_new_comment';
      BrowserStorage.setItem(
        'community_question_new_comment',
        $target
          .parent().parent()
          .find('.comment__new__textarea')
          .val(),
      );
    }
    viddsee.ui.modal.register.open(callback);
  });

  const $comments = $('#question #comments');
  // Add Comments
  $comments.on('click', '.comment__new__send', _addComment);

  // Load Comments
  $comments.on('vs:app:community:comment:load_more', (e) => {
    _loadComments();
  });

  $comments.on('click', '#comments__see-more', (e) => {
    $(e.currentTarget).prop('disabled', true);
    _loadComments();
  });

  // Like Comments
  $comments.on('vs:app:video:comment:like', (e) => {
    _voteHandler(e);
  });

  // Reply for Comments
  $comments.on('click', '.comment__item__reply, .comment__reply .btn-close', (e) => {
    if (
      $(e.currentTarget).hasClass('comment__item__reply') &&
      !$(e.currentTarget)
        .parents('.comment__item')
        .children('.comment__reply')
        .length
    ) {
      $(e.currentTarget).trigger('vs:app:community:comment:inject_reply_box');
      $(e.currentTarget).trigger('vs:ui:community:comment:reply:toggle');
    } else {
      $(e.currentTarget).trigger('vs:ui:community:comment:reply:toggle');
      $(e.currentTarget).trigger('vs:app:community:comment:destroy_reply_box');
    }
  });

  $comments.on('vs:app:community:comment:inject_reply_box', (e) => {
    _injectReplyBox(e);
  });

  $comments.on('vs:app:community:comment:destroy_reply_box', (e) => {
    _destroyReplyBox(e);
  });

  $comments.on('vs:app:community:comment:delete', (e, commentId) => {
    _deleteComment(e, commentId);
  });

  $('body').on('click', '.community-new-login-btn', (e) => {
    e.preventDefault();
    ga('send', 'event', 'community', 'login-add-discussion');
    viddsee.ui.modal.register.open({
      callback: 'new_discussion',
      loginReason: I18n.t('javascript.login-reason.common-community-interaction'),
    });
  });
};

const _addComment = async function _addComment(e) {
  e.preventDefault();
  const submitBtn = $(this);

  const l = Ladda.create(submitBtn[0]);
  l.start();

  const isNew = submitBtn.parent().hasClass('comment__new__submit');

  let body = submitBtn.parent().find('.comment__new__textarea');
  if (body.length === 0) {
    body = submitBtn
      .parent().parent()
      .find('.comment__new__textarea')
    ;
  }
  const bodyText = body.val().trim();
  if (bodyText.length === 0) {
    body.focus();
    l.stop();
    l.remove();
    return;
  }

  const params = {
    body: body.val(),
    in_reply_to: submitBtn.attr('data-id'),
  };

  try {
    const res = await webcall.community.postQuestionComment({
      question_id: _question.id,
      params,
    });

    if (isNew) {
      submitBtn.trigger('vs:ui:community:comment:new:clear');
    } else {
      submitBtn.trigger('vs:ui:community:comment:reply:toggle');
      submitBtn.trigger('vs:app:community:comment:destroy_reply_box');
    }
    _updateAddComment(res, submitBtn.attr('data-id'));
  } catch (error) {
    // TODO: Use a facade to log error
    window.Sentry && window.Sentry.captureException(error);
  } finally {
    l.stop();
    l.remove();
  }
};

const _updateAddComment = function _updateAddComment(response, replyTo) {
  // Let's pop the comment out!
  const tplCommentContainer = _.template($('.tpl-comment-container').html());
  const tplComment = _.template($('.tpl-comment').html());
  const thread = {
    comments: [],
  };

  const comment = response;
  comment.body = Autolinker.link(comment.body.replace(/(?:\r\n|\r|\n)/g, '<br>'));
  comment.created_at = moment(comment.created_at).fromNow();
  const values = {
    comment,
    admin: false, // FIXME: How I know this person admin? LOLOL
    isParent: !replyTo,
    isLogin: loginController.checkLogin(),
    isDeletable: BrowserStorage.getItem('user_id') === comment.user.id.toString(),
    url: window.location.protocol + '//' + window.location.hostname + '/community/' + _question.slug + '/comment/' + comment.id,
  };

  if (!replyTo) {
    thread.comments.push(tplComment(values));
    const commentContainer = $(tplCommentContainer({ thread }));
    $('.comment-content').prepend(commentContainer.hide().fadeIn('xslow'));
  } else {
    const commentBox = $('#c-' + replyTo);
    const commentContainer2 = commentBox.parent('.comment');
    // commentBox.children('.comment__item__reply').remove()
    commentContainer2.append(tplComment(values));
  }

  // dotdotdot ...
  $('.text-wrap-see-more').dotdotdot({
    after: $('<a href="#" class="comment__item__content__see-more">See more</a>'),
  });
};

const _loadComments = function _loadComments(e) {
  $('#comments__see-more').trigger('vs:ui:community:comment:see_more:start');

  webcall.community.getQuestionComments({
    question_id: _question.id,
    current_page: $('#comments__see-more').data('current-page') + 1,
  }, (data) => {
    if (BrowserStorage.getItem('access_token')) {
      webcall.user.get({}, (res) => {
        data.admin = res.admin_access;
        _displayComments(data);
      });
    } else {
      _displayComments(data);
    }
  });
};

const _displayComments = function _displayComments(data) {
  const tplCommentContainer = _.template($('.tpl-comment-container').html());
  const tplComment = _.template($('.tpl-comment').html());
  const $btnCommentsLoadMore = $('#comments__see-more');

  const comments = data.comments;

  for (let i = 0; i < comments.length; i++) {
    const thread = {
      comments: [],
    };

    const comment = comments[i];
    comment.bodyOriginal = comment.body;
    comment.body = Autolinker.link(comment.body.replace(/(?:\r\n|\r|\n)/g, '<br>'));
    comment.created_at = moment(comment.created_at).fromNow();

    const rootComment = {
      comment,
      admin: data.admin,
      isParent: true,
      isLogin: loginController.checkLogin(),
      isDeletable: BrowserStorage.getItem('user_id') === comment.user.id.toString(),
      url: window.location.protocol + '//' + window.location.hostname + '/community/' + _question.slug + '/comment/' + comment.id,
    };
    thread.comments.push(rootComment);

    // Add Replies
    if (comment.replies) {
      for (let j = 0; j < comment.replies.length; j++) {
        const reply = comment.replies[j];
        reply.bodyOriginal = reply.body;
        reply.body = Autolinker.link(reply.body.replace(/(?:\r\n|\r|\n)/g, '<br>'));
        reply.created_at = moment(reply.created_at).fromNow();

        const childComment = {
          comment: reply,
          admin: data.admin,
          isParent: false,
          isLogin: loginController.checkLogin(),
          isDeletable: BrowserStorage.getItem('user_id') === reply.user.id.toString(),
          url: window.location.protocol + '//' + window.location.hostname + '/community/question/' + _question.id + '/comment/' + reply.id,
        };
        thread.comments.push(childComment);
      }
    }

    for (let l = 0; l < thread.comments.length; l++) {
      thread.comments[l] = tplComment(thread.comments[l]);
    }

    $('.comment-content').append(tplCommentContainer({ thread }));
  }

  twemoji.parse(document.getElementById('comment-content'));
  // dotdotdot ...
  $('.text-wrap-see-more').dotdotdot({
    after: $('<a href="#" class="comment__item__content__see-more">See more</a>'),
  });

  $btnCommentsLoadMore.data('current-page', data.current_page);
  if (data.current_page + 1 < data.total_pages) {
    $btnCommentsLoadMore.show();
  } else {
    $btnCommentsLoadMore.trigger('vs:ui:community:comment:see_more:waypoints:destroy');
  }

  $('#comments__see-more').trigger('vs:ui:community:comment:see_more:stop');
};

const _voteHandler = function _voteHandler(e) {
  const $likeBtn = $(e.target);
  const commentId = $likeBtn.data('id');

  webcall.community.getCommentVote({
    question_id: _question.id,
    comment_id: commentId,
  }, (response) => {
    let text = '';
    if (response.likes === 0) {
      text = 'Likes';
    } else {
      text = response.likes === 1 ? response.likes + ' Like' : response.likes + ' Likes';
    }
    $likeBtn.html('<i class="fa fa-thumbs-o-up"></i> ' + text);
  });
};

const _injectReplyBox = function _injectReplyBox(e) {
  const tplReplyBox = _.template($('.tpl-comment-reply').html());
  const profileImage = BrowserStorage.getItem('profile_image_url') ? BrowserStorage.getItem('profile_image_url') : '';

  const data = {
    id: $(e.target).data('reply-to'),
    profile_image: profileImage,
  };

  $(e.target)
    .parents('.comment__item')
    .append(tplReplyBox({ data }))
  ;
};

const _destroyReplyBox = function _destroyReplyBox(e) {
  if ($(e.target).hasClass('comment__item__reply')) {
    $(e.target)
      .parents('.comment__item')
      .children('.comment__reply')
      .remove()
    ;
  } else {
    $(e.target)
      .parent('.comment__reply')
      .remove()
    ;
  }
};

const _deleteComment = function _deleteComment(e, commentId) {
  const comment = $('#c-' + commentId);
  const body = comment.children('.comment__item__content');

  webcall.community.deleteComment({
    question_id: _question.id,
    comment_id: commentId,
  }, (res, err) => {
    comment.addClass('deleted');
    body.html(I18n.t('javascript.video.action.conversations.delete_confirmation'));
    comment.children('.comment__item__delete').hide();
    comment.children('.comment__item__reply').hide();
    comment.children('.comment__item__recommend').hide();

    comment.trigger('vs:ui:community:comment:delete:toggle');
  });
};

const _flag = function _flag(e, isComment) {
  const $target = $(e.target);
  const type = $target.data('type');
  const commentId = $target.data('comment-id');
  webcall.community.postFlag({
    question_id: $target.data('question-id'),
    comment_id: $target.data('comment-id'),
    type,
    params: {
      reason: $target.text(),
    },
  }, (response, err) => {
    $target.trigger('vs:ui:community:flag:toggle');
    if (isComment) {
      const $flagTarget = $('.js-community-flag[data-type="' + type + '"][data-comment-id="' + commentId + '"]');
      if ($flagTarget.hasClass('btn')) {
        $flagTarget.trigger('vs:ui:community:flag:flagged');
      } else {
        $flagTarget.attr('disabled', true).addClass('deleted');
      }
    } else {
      $('.js-community-flag[data-type="' + type + '"]').trigger('vs:ui:community:flag:flagged');
    }
  });
};

const _share = function _share(e, params) {
  const $target = $(e.target);
  switch ($target.data('type')) {
    case 'facebook':
      socialSharer.shareFB(e, params);
      break;
    case 'twitter':
      socialSharer.shareTW(e, params);
      break;
    case 'email':
      socialSharer.shareEmail(e, params);
      break;
    default: break;
  }
};

const init = function init() {
  // FIXME: @cpwc fix this.
  if (window.location.href.indexOf('community') === -1) {
    return;
  }

  UIHelper.relativeTime();

  UICommunity.registerEventBindings();

  VSCommunityQuestion.init();
  VSCommunityResponse.init();

  _initPageData();
  _initProfileImageInitial();
  _bindUIActions();

  // FIXME: You know you should clean this up right?
  // Trigger UI updates if the user is or NOT logged in
  loginController.checkLoginStatus((status) => {
    if (status === 'signed_in') {
      if (BrowserStorage.getItem('profile_image_url') !== 'null') {
        $('.comment__new__submit__user img.avatar').attr('src', BrowserStorage.getItem('profile_image_url'));
      } else {
        $('.comment__new__submit__user img.avatar')
          .addClass('default-profile')
          .data('name', BrowserStorage.getItem('first_name'))
        ;
        $('.comment__new__submit__user.default-profile')
          .initial()
        ;
      }
      $('.comment__new__submit .comment__new__send--login')
        .addClass('comment__new__send')
        .attr('data-event-category', 'community')
        .attr('data-event-action', 'click-comment')
        .removeClass('comment__new__send--login')
      ;
      $('.comment__new__submit .ladda-label')
        .text('Send')
      ;
      $('.comment__new__submit .comment__new__submit__user p span')
        .text(BrowserStorage.getItem('first_name'))
      ;
      $('.js-community-flag-login')
        .addClass('js-community-flag')
        .removeClass('js-community-flag-login')
      ;
      $('.community-new-login-btn')
        .attr('data-event-action', 'add-discussion')
        .removeClass('community-new-login-btn')
      ;
    }
  });

  const paramsSize = Object.keys(AcHelper.getParams()).length;
  if ($('#question').length !== 0) {
    // Check for page callbacks from login
    if (paramsSize === 1 && AcHelper.getParams()['callback'] === 'community_question_new_comment') {
      const $commentNew = $('.comment__new');
      $commentNew.children('.comment__new__textarea').val(BrowserStorage.getItem('community_question_new_comment'));
      BrowserStorage.removeItem('community_question_new_comment');
      UIHelper.scrollTo($commentNew);
    }

    _loadComments();
  }

  if (paramsSize === 1 && AcHelper.getParams()['callback'] === 'new_discussion') {
    window.location.href = window.location.protocol + '//' + window.location.hostname + '/community/question/new';
  }
};

const VSCommunity = {
  init,
};

export default VSCommunity;
